import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { CardContent } from '@mui/material';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import React from 'react';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import EditNoteIcon from '@mui/icons-material/EditNote';
import AssemblyBudget from './LaborPriceEstimation';
import AssemblyBudgetCalculate from './AssemblyBudgetCalculate';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ShippingTotalCostCalculate from './ShippingTotalCostCalculate';

function AssemblyBudgetDynamicTab() {

    const [value, setValue] = React.useState('1')

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <>
            <Card>
                <CardContent>
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                        <TabContext value={value}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList variant='fullWidth' centered onChange={handleChange}
                                    sx={{
                                        textColor: '#424242',
                                        "& .css-xe9pe1-MuiButtonBase-root-MuiTab-root.Mui-selected": {
                                            color: "#FF9800"
                                        }, "& .css-10hkket.Mui-selected": {
                                            color: "#FF9800"
                                        },
                                    }}
                                >
                                    <Tab sx={{ width: '100%' }} icon={<CompareArrowsIcon />} label="Montaj Adet Hesaplama" value="1" />
                                    <Tab sx={{ width: '100%' }} icon={<LocalShippingIcon />} label="Nakliye Bütçe Hesaplama" value="2" />
                                </TabList>
                                <TabPanel value="1">
                                    <AssemblyBudget />
                                </TabPanel>
                                <TabPanel value="2">
                                    <ShippingTotalCostCalculate />
                                </TabPanel>
                            </Box>
                        </TabContext>
                    </Box>
                </CardContent>
            </Card>
        </>
    )
}

export default AssemblyBudgetDynamicTab;